export default () => ({
  list: [],
});
